import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PersonalDataService } from '../personal-data.service';
import { LookupOptionsData } from '../../jurisdiction.domain';
import { AllDropdownKeys } from '../../jurisdiction.constants';
import { CommonService } from '../../../services/common.service';
import { EnvironmentService } from '../../../services/environment.service';
import { ValidationsService } from 'src/app/services/validations.service';
import { SectionIdentifier } from 'src/app/+shared/components/review-section/review-section.domain';

@Component({
  selector: 'app-installer-company',
  templateUrl: './installer-company.component.html',
  styleUrls: ['./installer-company.component.scss'],
})
export class InstallerCompanyComponent implements OnInit {
  @Input() systemCompanyInstallerData: any;
  @Input() isReadOnly: boolean = false;
  @Input() applicationId: string | number;
  @Input() isDetailsView: boolean;

  systemCompanyInstallerFG: FormGroup;
  // installerCompanyFG: FormGroup;
  infoBubblesData: {
    [key: string]: boolean;
  };
  titles: LookupOptionsData[];
  titleKey: string;
  shouldMarkFirstAndLastNameAsMandatory: boolean;
  shouldRestrictStreetNumberTo5Chars: boolean;
  sectionIdentifier = SectionIdentifier;

  constructor(
    private commonService: CommonService,
    private personalDataService: PersonalDataService,
    private environmentService: EnvironmentService
  ) {}

  ngOnInit(): void {
    this.titleKey = AllDropdownKeys.Title;
    this.titles = this.commonService.getDropdownData(this.titleKey);
    this.infoBubblesData = this.environmentService.getInfoBubblesData('personalData') || null;
    this.shouldMarkFirstAndLastNameAsMandatory = this.environmentService.shouldMarkFirstAndLastNameAsMandatory;
    this.shouldRestrictStreetNumberTo5Chars = this.environmentService.shouldRestrictStreetNumberTo5Chars;
    this.prepareForm();
    this.personalDataService.updatePersonalDataForm(this.systemCompanyInstallerFG, 'installerSystem');
    // this.personalDataService.updatePersonalDataForm(this.installerCompanyFG, 'installerCompany');
  }

  private prepareForm(): void {
    this.systemCompanyInstallerFG = new FormGroup({
      system_taxId: new FormControl(this.systemCompanyInstallerData.system_taxId || ''),
      system_title: new FormControl(this.systemCompanyInstallerData.system_title || ''),
      system_company: new FormControl(this.systemCompanyInstallerData.system_company || '', [Validators.required]),
      system_name: new FormControl(this.systemCompanyInstallerData.system_name || ''),
      system_street: new FormControl(this.systemCompanyInstallerData.system_street || '', [Validators.required]),
      system_firstName: new FormControl(this.systemCompanyInstallerData.system_firstName || ''),
      system_streetNumber: new FormControl(this.systemCompanyInstallerData.system_streetNumber || '', [
        Validators.required,
        ValidationsService.streetNumberValidator(),
      ]),
      system_telephone: new FormControl(this.systemCompanyInstallerData.system_telephone || ''),
      system_postCode: new FormControl(this.systemCompanyInstallerData.system_postCode || '', [
        Validators.required,
        ValidationsService.maxLengthValidator(),
      ]),
      system_city: new FormControl(this.systemCompanyInstallerData.system_city || ''),
      system_telephoneCentral: new FormControl(this.systemCompanyInstallerData.system_telephoneCentral || '', [Validators.required]),
    });

    if (this.shouldMarkFirstAndLastNameAsMandatory) {
      this.systemCompanyInstallerFG.controls.system_title.setValidators([Validators.required]);
      this.systemCompanyInstallerFG.controls.system_name.setValidators([Validators.required]);
      this.systemCompanyInstallerFG.controls.system_firstName.setValidators([Validators.required]);
      this.systemCompanyInstallerFG.controls.system_title.updateValueAndValidity();
      this.systemCompanyInstallerFG.controls.system_name.updateValueAndValidity();
      this.systemCompanyInstallerFG.controls.system_firstName.updateValueAndValidity();
    }

    if (this.shouldRestrictStreetNumberTo5Chars) {
      this.systemCompanyInstallerFG.controls.system_streetNumber.setValidators([Validators.maxLength(5)]);
      this.systemCompanyInstallerFG.controls.system_streetNumber.updateValueAndValidity();
    }

    // this.installerCompanyFG = new FormGroup({
    //   company_taxId: new FormControl(
    //     {value: this.systemCompanyInstallerData.company_taxId || '', disabled: this.isReadOnly}),
    //   company_title: new FormControl(
    //     {value: this.systemCompanyInstallerData.company_title || '', disabled: this.isReadOnly}),
    //   company: new FormControl(
    //     {value: this.systemCompanyInstallerData.company || '', disabled: this.isReadOnly},
    //     [Validators.required]),
    //   company_name: new FormControl(
    //     {value: this.systemCompanyInstallerData.company_name || '', disabled: this.isReadOnly}),
    //   company_street: new FormControl(
    //     {value: this.systemCompanyInstallerData.company_street || '', disabled: this.isReadOnly},
    //     [Validators.required]),
    //   company_firstName: new FormControl(
    //     {value: this.systemCompanyInstallerData.company_firstName || '', disabled: this.isReadOnly}),
    //   company_streetNumber: new FormControl(
    //     {value: this.systemCompanyInstallerData.company_streetNumber || '', disabled: this.isReadOnly},
    //     [Validators.required]),
    //   company_telephone: new FormControl(
    //     {value: this.systemCompanyInstallerData.company_telephone || '', disabled: this.isReadOnly}),
    //   company_postCode: new FormControl(
    //     {value: this.systemCompanyInstallerData.company_postCode || '', disabled: this.isReadOnly},
    //     [Validators.required]),
    //   company_city: new FormControl(
    //     {value: this.systemCompanyInstallerData.company_city || '', disabled: this.isReadOnly}),
    //   company_telephoneCentral: new FormControl(
    //     {value: this.systemCompanyInstallerData.company_telephoneCentral || '', disabled: this.isReadOnly},
    //     [Validators.required])
    // });

    this.systemCompanyInstallerFG.valueChanges.subscribe(() => {
      this.personalDataService.updatePersonalDataForm(this.systemCompanyInstallerFG, 'installerSystem');
    });
    // this.installerCompanyFG.valueChanges.subscribe(() => {
    //   this.personalDataService.updatePersonalDataForm(this.installerCompanyFG, 'installerCompany');
    // });
  }
}
